import React from 'react';
import { Page } from 'react-onsenui';
import * as sdkclaro from '@claropay/claro-pay-sdk-v2'
import styled from 'styled-components';

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100vh;
  border: none;
`;
const ContactsPage = ({ match, location }) => {
    const { 
        state: { url }
    } = location;
  
    sdkclaro.getInstance().switchGoBackButton(true)

    return (
        <Page id="contacts-page">
            <StyledIframe src={url} />
        </Page>    
  );
};


export default ContactsPage